// Dia en que el gestor visita al cliente. No se incluye domingo porque no se cobra.
export const DIAS_ATENCION = ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO'];

/**
 * En las periodicidades diarias se cobra todos los dias, asi que el dia de
 * atencion no aplica.
 *
 * Se detecta por `cuotaDias` (1 = diario) y no por el id del catalogo, igual que
 * en el backend: hoy hay tres periodicidades diarias con ids 5, 6 y 1008, y
 * cualquier periodicidad nueva que se agregue tendria un id alto sin ser diaria.
 */
export const requiereDiaAtencion = (periodicidad) =>
	!!periodicidad && periodicidad.cuotaDias > 1;
